import { AdminSidebar } from '@/components/AdminSidebar';
import { Outlet } from 'react-router';

export function AdminLayout() {
  return (
    <div className="flex h-screen overflow-hidden bg-surface-50">
      {/* Sidebar */}
      <AdminSidebar />
      {/* Main Content */}
      <main className="flex-1 flex flex-col min-w-0 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
